<template>
  <div>
    <Header></Header>

    <!-- SECTION -->
    <div class="section">
      <!-- container -->
      <div class="container">
        <!-- row -->
        <div class="row">
          <div class="col-md-4">
            <!-- post widget -->
            <div class="aside-widget">
              <div class="section-title">
                <h2 class="title">Filtros</h2>

                <p class="input-label-top">Faixa Etária</p>
                <select v-model="objSearch.category" class="my-input">
                  <option value>TODAS</option>
                  <option v-for="cat in categories" :key="cat.id">{{
                    cat.title
                  }}</option>
                </select>

                <p class="input-label-top">Palavra-chave</p>
                <input
                  type="text"
                  class="my-input"
                  v-model="objSearch.text"
                  placeholder="Busque por palavras-chaves, termos, etc"
                />

                <div v-show="objSearch.tag">
                  <p class="input-label-top">Hashtag</p>
                  <span class="hashtag-item">
                    {{ objSearch.tag }}
                    <div @click="removeTag()" class="remove">X</div>
                  </span>
                </div>
                <div class="radio-holder mt-1">
                  <input
                    v-model="objSearch.urgency"
                    type="checkbox"
                    name="urgencia"
                    id="urg"
                  />
                  <label for="urg">Somente Urgências</label>
                </div>

                <div v-show="loading" class="loading-holder">
                  <div class="loading-spinner"></div>
                </div>

                <div
                  @click="applyFilters"
                  v-show="!loading"
                  class="primary-button btn-filter-search"
                >
                  <div>Aplicar filtros</div>
                </div>
              </div>
            </div>
            <!-- /post widget -->
          </div>
          <div class="col-md-8">
            <!-- row -->
            <div class="row">
              <div class="col-md-12">
                <div class="section-title">
                  <h2 class="title">Artigos</h2>
                </div>
              </div>

              <!-- post -->
              <div
                class="post post-row"
                v-for="post in searchList"
                :key="post.id"
              >
                <a class="post-img" :href="'/#/post/' + post.slug">
                  <img :src="post.image" :alt="post.title" />
                </a>
                <div class="post-body">
                  <div class="post-category">
                    <a
                      class="mr-1"
                      v-for="tag in post.tag.slice(0, 4)"
                      :key="tag.id"
                      href
                      >{{ tag.title }}</a
                    >
                  </div>
                  <h3 class="post-title">
                    <a :href="'/#/post/' + post.slug">{{ post.title }}</a>
                  </h3>
                  <ul class="post-meta">
                    <li>
                      <a href>{{ post.user.name }}</a>
                    </li>
                    <li>{{ post.timestamp | moment("DD/MM/YYYY") }}</li>
                  </ul>
                  <p
                    class="post-card-description"
                    v-html="post.description"
                  ></p>
                </div>
              </div>
              <!-- /post -->

              <div
                v-show="!loading && searchList.length < 1"
                class="loading-holder mt-3"
              >
                <p style="color:var(--secondary); text-align:center;">
                  Não encontramos o que você procura.<br />
                  <br />
                  <b>Tente outras buscas!</b>
                </p>
              </div>

              <div v-show="loading" class="loading-holder">
                <div class="loading-spinner"></div>
              </div>

              <div v-show="resultsLength > 19">
                <div
                  @click="search"
                  class="section-row loadmore text-center"
                  style="cursor:pointer;"
                >
                  <a v-show="!loading" class="primary-button">Ver Mais</a>
                </div>
              </div>
            </div>
            <!-- /row -->
          </div>
        </div>
        <!-- /row -->
      </div>
      <!-- /container -->
    </div>
    <!-- /SECTION -->

    <Footer></Footer>
  </div>
</template>

<script>
import http from "@/http";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Newsletter from "../components/Newsletter";

export default {
  name: "Search",
  components: {
    Header,
    Footer,
    Newsletter
  },
  data() {
    return {
      loading: false,
      objSearch: {
        text: "",
        category: "",
        urgency: false,
        tag: "",
        page: 0,
        take: 20
      },
      resultsLength: 0,
      categories: [],
      searchList: []
    };
  },
  created() {
    this.objSearch.text = this.$route.query.text || "";
    this.objSearch.category = this.$route.query.category || "";
    this.objSearch.urgency = this.$route.query.urgencia == 1 ? true : false;
    this.objSearch.tag = this.$route.query.tag || "";

    this.search();
    this.loadCategories();
  },
  methods: {
    search() {
      this.loading = true;
      http
        .get(
          `post/search?text=${this.objSearch.text}&urgency=${
            this.objSearch.urgency
          }&category=${this.objSearch.category}&page=${
            this.objSearch.page
          }&take=${this.objSearch.take}&tag=${this.objSearch.tag}`
        )
        .then(response => {
          this.resultsLength = response.data.list.length;
          if (this.objSearch.page == 0) {
            this.searchList = response.data.list;
          } else {
            this.searchList = [...this.searchList, ...response.data.list];
          }
          this.objSearch.page++;
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    removeTag() {
      this.objSearch.tag = "";
      this.applyFilters();
    },
    applyFilters() {
      this.searchList = [];
      this.objSearch.page = 0;
      this.search();
    },
    loadCategories() {
      http
        .get("category")
        .then(response => {
          this.categories = response.data.list;
        })
        .catch(err => {
          console.log(err);
        });
    }
  }
};
</script>

<style scoped>
.hashtag-item {
  position: relative;
  display: inline-block;
  padding: 4px 12px;
  border-radius: 3px;
  margin-top: 4px;
  background-color: var(--secondary);
  color: #fff;
}

.hashtag-item .remove {
  position: absolute;
  right: -9px;
  top: -9px;
  width: 18px;
  height: 18px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #000;
  background-color: #fff;
  border-radius: 100%;
  border: 1px solid #555;
  font-size: 0.5em;
  font-weight: bold;
  cursor: pointer;
}

.radio-holder {
  position: relative;
  height: 24px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.radio-holder input {
  position: relative;
  width: 20px;
  height: 20px;
  margin: 0 10px 0 0;
}

.radio-holder label {
  margin: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/Search.vue